import styles from "./journalcard.module.css";
import { Trash2, AlertTriangle } from "react-feather";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";

const JournalCard = ({ item, setDeleteId, setDeleteModalOpen }) => {
    const { user, isAuthenticated } = useAuth0();
    const categoryLabel = item?.is_unusual === 1 ? "INCIDENT" : "NOTE";
    const badgeStyleClass = item?.is_unusual === 1 ? styles.incidentBadge : styles.noteBadge;

    // Parse snippet from description (remove HTML tags)
    const snippet = item?.description ? item.description.replace(/<[^>]*>/g, '') : '';

    return (
        <Link to={"/security/journal/details/" + item?.id} className={`${styles.JournalListCard}`}>
            <div className={`${styles.JournalImageSec}`}>
                <p>{item?.user_initial || "U"}</p>
            </div>
            <div className={`${styles.JournalDesSec}`}>
                <div className={styles.TitleRow}>
                    <span className={styles.Title}>{item?.title || "Journal Entry"}</span>
                    {item?.is_unusual === 1 && <AlertTriangle className={styles.unusualIcon} />}
                </div>
                <p className={`${styles.JournalTextSec}`}>
                    {item?.user_name} 
                    <span>{item?.property_name}</span>
                    {dayjs(item?.date).isValid() && <span>{dayjs(item?.date).format("MMM DD, YYYY")}</span>}
                </p>
                <div className={`${styles.SummCommBodyText}`}>{snippet}</div>
            </div>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1 && (
                <button 
                    className={`${styles.DeleteJournalBU}`} 
                    onClick={(e) => { 
                        e.preventDefault(); 
                        e.stopPropagation(); 
                        setDeleteId(item?.id); 
                        setDeleteModalOpen(true); 
                    }}
                >
                    <Trash2 />
                </button>
            )}
        </Link>
    );
};

export default JournalCard;